import { render, staticRenderFns } from "./XNavMenu.vue?vue&type=template&id=06a75784"
import script from "./XNavMenu.vue?vue&type=script&lang=ts"
export * from "./XNavMenu.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports